import { DateFormatterToken } from '../../../types/functions/date-formatter-token';
import { UnicodeDateFormatterToken } from '../../../types/functions/unicode-date-formatter-token';
import { formattingTokensRegex } from '../format-date';
// Create a map from old tokens to their modern unicode equivalent
const unicodeTokenMap = Object.entries(DateFormatterToken).reduce((acc, [name, value]) => {
    return Object.assign(Object.assign({}, acc), { [value.toString()]: UnicodeDateFormatterToken[name] });
}, {});
/**
 * Converts a legacy date format to unicode format that is compatible with date-fns v2
 * @param formatString The legacy date format string to convert
 */
export function convertDateFormatToUnicode(formatString) {
    const matches = formatString.match(formattingTokensRegex);
    const tokens = matches.filter(Boolean).map(match => unicodeTokenMap[match] || match);
    return tokens.join('');
}
//# sourceMappingURL=convert-date-format-to-unicode.js.map